import clsx from 'clsx';
import { type PropsWithChildren, type ReactNode } from 'react';

import { Icon } from '../../icon';
import { Divider } from '../../divider';
import { Button, type ButtonProps } from '../../button';

import styles from '../alert.module.scss';

export const AlertMessage = (props: AlertMessageProps) => {
  const {
    icon,
    type,
    title,
    color,
    message,
    className,
    primaryButton,
    secondaryButton,
    contentClassName,
    withDividers = true,
    ...rest
  } = props;

  return (
    <div
      className={clsx(styles.message, className, {
        [styles.withDividers]: withDividers,
      })}
      {...rest}
    >
      <div className={styles.header}>
        {type === 'danger' && typeof title === 'string' ? (
          <>
            Delete
            <span>{` ${title}`}?</span>
          </>
        ) : (
          title
        )}
      </div>
      <Divider orientation="horizontal" className={styles.divider} />
      <div className={clsx(styles.alertMessageContent, styles[`t-${type}`], styles[`c-${color}`], contentClassName)}>
        {icon && (
          <div className={styles.icon}>
            <Icon multiColor type={icon} size={30} />
          </div>
        )}
        <div>{message}</div>
      </div>
      <div className={styles.footer}>
        <Divider orientation="horizontal" className={styles.divider} />
        <div className={styles.fButtons}>
          <Button
            tabIndex={1}
            cornerRadius="rounded"
            data-testid="alert-secondary-btn"
            onClick={secondaryButton?.onClick}
            {...secondaryButton}
          >
            {secondaryButton?.children || 'Cancel'}
          </Button>
          {!!primaryButton && (
            <Button tabIndex={2} cornerRadius="rounded" color="success" data-testid="alert-primary-btn" {...primaryButton}>
              {primaryButton?.children}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

interface AlertMessageProps extends PropsWithChildren {
  icon?: string;
  message?: string;
  title?: ReactNode;
  maxWidth?: number;
  className?: string;
  withDividers?: boolean;
  contentClassName?: string;
  primaryButton?: ButtonProps;
  secondaryButton?: ButtonProps;
  color?: 'danger' | 'hero';
  type?: 'danger' | 'warning' | 'info';
}
